import io from "socket.io-client";
import api from "./api";
import { getBackendUrl } from "../config";

class SocketWorker {
  constructor(companyId, userId) {
    const token = api.defaults.headers.Authorization;
    const current = SocketWorker.instance;
    if (current && !current.disposed && current.companyId === companyId && current.userId === userId && current.token === token) return current;
    current?.disconnect();
    this.companyId = companyId;
    this.userId = userId;
    this.token = token;
    this.disposed = false;
    this.eventListeners = {};
    const proxy = !!window.__whitelabelBackendUrl;
    this.socket = io(`${proxy ? window.location.origin : getBackendUrl()}/${companyId}`, {
      forceNew: true,
      ...(proxy ? { path: "/backend/socket.io" } : {}),
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      query: { userId, token, portalHost: window.location.hostname },
    });
    SocketWorker.instance = this;
  }

  on(event, callback) {
    if (this.disposed) return;
    if (!this.eventListeners[event]) this.eventListeners[event] = new Set();
    if (this.eventListeners[event].has(callback)) return;
    this.eventListeners[event].add(callback);
    this.socket.on(event, callback);
  }

  emit(event, data) {
    if (!this.disposed) this.socket.emit(event, data);
  }

  off(event, callback) {
    // Cleanup must never establish another connection after logout.
    if (this.disposed || !this.eventListeners[event]) return;
    if (callback) {
      this.socket.off(event, callback);
      this.eventListeners[event].delete(callback);
    } else {
      this.eventListeners[event].forEach((listener) => this.socket.off(event, listener));
      delete this.eventListeners[event];
    }
  }

  disconnect() {
    if (this.disposed) return;
    this.disposed = true;
    this.socket.removeAllListeners();
    this.socket.disconnect();
    this.eventListeners = {};
    if (SocketWorker.instance === this) SocketWorker.instance = null;
  }

  connect() {
    if (!this.disposed && !this.socket.connected) this.socket.connect();
  }

  forceReconnect() {
    if (!this.disposed) { this.socket.disconnect(); this.socket.connect(); }
  }
}

const createSocketWorker = (companyId, userId) => new SocketWorker(companyId, userId);
export const disconnectSocket = () => SocketWorker.instance?.disconnect();
export default createSocketWorker;
